(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('imperfect-bundle')) {
    customElements.define(
      'imperfect-bundle',
      class ImperfectBundle extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          const configEl = this.previousElementSibling?.matches?.('[data-bundle-builder-config]')
            ? this.previousElementSibling
            : document.querySelector('[data-bundle-builder-config]');
          this.config = JSON.parse(configEl?.textContent || '{}');
          this.currency = this.config.currency || 'KWD';
          this.minPacks = Number(this.config.minPacks || 6);
          this.maxPacks = Number(this.config.maxPacks || 10);
          if (this.maxPacks < this.minPacks) this.maxPacks = this.minPacks;
          this.discountPercent = Number(this.config.discountPercent || 0);
          this.setupGallery();
          this.setupCards();
          this.setupAddToCart();
          this.updateTotals();
        }

        cartDestination() {
          const url = new URL(this.config.cartUrl || '/cart', window.location.origin);
          const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          return url.toString();
        }

        formatMoney(amount) {
          try {
            return new Intl.NumberFormat(undefined, {
              style: 'currency',
              currency: this.currency,
            }).format(amount);
          } catch (error) {
            return amount.toFixed(3);
          }
        }

        saleAmount(amount) {
          if (!this.discountPercent) return amount;
          const digits = ['KWD', 'BHD', 'OMR', 'JOD'].includes(this.currency) ? 3 : 2;
          const factor = 10 ** digits;
          return Math.round(amount * (1 - this.discountPercent / 100) * factor) / factor;
        }

        setupGallery() {
          const main = this.querySelector('.bundle-builder__main-image');
          this.querySelectorAll('.bundle-builder__thumb').forEach((thumb) => {
            thumb.addEventListener('click', () => {
              this.querySelectorAll('.bundle-builder__thumb').forEach((item) => item.classList.remove('is-active'));
              thumb.classList.add('is-active');
              if (main && thumb.dataset.image) main.src = thumb.dataset.image;
            });
          });
        }

        cardAvailable(card) {
          return card.dataset.available !== 'false';
        }

        cardMaxQty(card) {
          if (!Object.hasOwn(card.dataset, 'maxQty')) return Infinity;
          const max = Number(card.dataset.maxQty);
          return Number.isFinite(max) && max >= 0 ? max : Infinity;
        }

        bundleQtyExcept(exceptCard) {
          let total = 0;
          this.querySelectorAll('[product-bundle-item]').forEach((card) => {
            if (card === exceptCard) return;
            const radio = card.querySelector('.bundle-builder__radio');
            const qty = Number(card.querySelector('.bundle-builder__qty-input')?.value || 0);
            if (this.cardAvailable(card) && radio?.checked && qty > 0) total += qty;
          });
          return total;
        }

        clampCardQty(card, value) {
          const next = Math.max(0, Math.floor(Number(value) || 0));
          const inventoryMax = this.cardMaxQty(card);
          const bundleRoom = this.maxPacks - this.bundleQtyExcept(card);
          let max = bundleRoom;
          if (inventoryMax !== Infinity) max = Math.min(max, inventoryMax);
          return Math.min(next, Math.max(0, max));
        }

        syncQtyControls(card) {
          const qtyInput = card.querySelector('.bundle-builder__qty-input');
          const plus = card.querySelector('.bundle-builder__qty-btn.plus');
          if (!qtyInput || !plus) return;
          const qty = Number(qtyInput.value || 0);
          plus.disabled = !this.cardAvailable(card) || this.clampCardQty(card, qty + 1) <= qty;
        }

        setupCards() {
          this.querySelectorAll('[product-bundle-item]').forEach((card) => {
            const radio = card.querySelector('.bundle-builder__radio');
            const qtyInput = card.querySelector('.bundle-builder__qty-input');
            const minus = card.querySelector('.bundle-builder__qty-btn.minus');
            const plus = card.querySelector('.bundle-builder__qty-btn.plus');

            const select = (quantity = 1) => {
              if (!this.cardAvailable(card)) return;
              const next = this.clampCardQty(card, quantity);
              if (next < 1) return;
              radio.checked = true;
              card.classList.add('is-selected');
              qtyInput.value = next;
              this.syncQtyControls(card);
              this.updateTotals();
            };

            const deselect = () => {
              radio.checked = false;
              card.classList.remove('is-selected');
              qtyInput.value = 0;
              this.syncQtyControls(card);
              this.updateTotals();
            };

            this.syncQtyControls(card);

            card.addEventListener('click', (event) => {
              if (!this.cardAvailable(card)) return;
              if (event.target.closest('.bundle-builder__qty')) return;
              if (!radio.checked) select(1);
            });

            minus.addEventListener('click', (event) => {
              event.stopPropagation();
              if (!this.cardAvailable(card)) return;
              const next = this.clampCardQty(card, Number(qtyInput.value || 1) - 1);
              if (next < 1) deselect();
              else select(next);
            });

            plus.addEventListener('click', (event) => {
              event.stopPropagation();
              if (!this.cardAvailable(card)) return;
              select(Number(qtyInput.value || 0) + 1);
            });

            qtyInput.addEventListener('change', () => {
              if (!this.cardAvailable(card)) {
                deselect();
                return;
              }
              const next = this.clampCardQty(card, qtyInput.value);
              if (next < 1) deselect();
              else select(next);
            });
          });
        }

        selectedItems() {
          const items = [];
          this.querySelectorAll('[product-bundle-item]').forEach((card) => {
            const radio = card.querySelector('.bundle-builder__radio');
            const qty = Number(card.querySelector('.bundle-builder__qty-input').value || 0);
            if (this.cardAvailable(card) && radio.checked && qty > 0) {
              items.push({
                id: radio.value,
                quantity: this.clampCardQty(card, qty),
                price: Number(radio.dataset.price || 0),
              });
            }
          });
          return items;
        }

        updateTotals() {
          const items = this.selectedItems();
          const totalQty = items.reduce((sum, item) => sum + item.quantity, 0);
          const originalTotal = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
          const saleTotal = items.reduce(
            (sum, item) => sum + this.saleAmount(item.price) * item.quantity,
            0
          );
          const eligible = totalQty >= this.minPacks && totalQty <= this.maxPacks;
          const note = this.querySelector('[data-bundle-note]');
          const button = this.querySelector('.bundle-builder__atc');
          const totalEl = this.querySelector('.bundle-builder__total');
          const compareEl = this.querySelector('.bundle-builder__total-compare');
          const remaining = this.minPacks - totalQty;

          button.disabled = !eligible;
          totalEl.textContent = this.formatMoney(saleTotal);
          if (compareEl) {
            const showCompare = this.discountPercent > 0 && originalTotal > 0;
            compareEl.hidden = !showCompare;
            compareEl.textContent = showCompare ? this.formatMoney(originalTotal) : '';
          }

          if (totalQty === 0) {
            note.hidden = false;
            note.textContent = this.config.strings.minPacks;
          } else if (eligible) {
            note.hidden = totalQty < this.maxPacks;
            if (totalQty >= this.maxPacks) note.textContent = this.config.strings.maxPacks;
          } else {
            note.hidden = false;
            note.textContent =
              remaining === 1
                ? this.config.strings.addMoreOne
                : this.config.strings.addMoreOther.replace('2', String(remaining));
          }

          this.querySelectorAll('[product-bundle-item]').forEach((card) => this.syncQtyControls(card));
        }

        setupAddToCart() {
          const button = this.querySelector('.bundle-builder__atc');
          const spinner = this.querySelector('.bundle-builder__atc-spinner');

          button.addEventListener('click', async (event) => {
            event.preventDefault();
            const items = this.selectedItems();
            if (!items.length || button.disabled) return;

            spinner.hidden = false;
            button.disabled = true;

            const body = {
              items: items.map((item) => ({
                id: Number(item.id),
                quantity: Number(item.quantity),
                properties: {
                  _bundle_id: String(this.config.bundleId),
                },
              })),
            };

            try {
              const response = await fetch(this.config.cartAddUrl, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                  'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify(body),
              });
              const text = await response.text();
              let data = {};
              try {
                data = JSON.parse(text);
              } catch (parseError) {
                throw new Error(this.config.strings.error);
              }

              const added = Array.isArray(data.items) && data.items.length > 0;
              if (!response.ok || !added) {
                throw new Error(data.description || data.message || this.config.strings.error);
              }

              document.dispatchEvent(
                new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: data,
                    sourceId: this.dataset.sectionId,
                    data: { source: 'bundle-builder' },
                  },
                })
              );

              window.location.href = this.cartDestination();
            } catch (error) {
              const note = this.querySelector('[data-bundle-note]');
              note.hidden = false;
              note.textContent = error.message || this.config.strings.error;
              spinner.hidden = true;
              this.updateTotals();
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
